import { render, staticRenderFns } from "./DirectDrinkingWaterSubsystem.vue?vue&type=template&id=4ec63de6"
import script from "./DirectDrinkingWaterSubsystem.vue?vue&type=script&lang=js"
export * from "./DirectDrinkingWaterSubsystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports